module.exports = __webpack_public_path__ + "static/img/报修.52280af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/报修.png
// module id = BffA
// module chunks = 2